export const TnCRegion = ['br', 'co', 'mx', 'ar', 'id', 'pk', 'kr'];
export enum CouponEntryABTest {
  Normal = 0,
  NewCouponEntry,
  EntryAndModal,
}
export const APPIDS = {
  M: '1233',
  T: '1180',
  LITE: '1340'
};
export const PRE_HEAT_CALENDAR_KEY = 'pre_heating_id_register';
export const FRIENDS_EACH_ROUND = 5;
export const APP_INFO = {
  M_PACKAGE: 'com.zhiliaoapp.musically',
  T_PACKAGE: 'com.ss.android.ugc.trill',
  LITE_PACKAGE: 'com.zhiliaoapp.musically.go',
  M_STORE: '835599320',
  T_STORE: '1235601864',
  M_NAME: 'musical.ly',
  T_NAME: 'TIKTOK',
  M_FACEBOOK_ID: '597615686992125',
  T_FACEBOOK_ID: '1862952583919182'
};
export const onelinkMap = {
  1180: {
    schema: 'snssdk1180://webview',
    link: 'https://snssdk1180.onelink.me/BAuo'
  },
  1233: {
    schema: 'snssdk1233://webview',
    link: 'https://snssdk1233.onelink.me/bIdt'
  },
  1340: {
    schema: 'snssdk1340://webview',
    link: 'https://snssdk1340.onelink.me/k3Nj'
  }
};
export const androidAppStore = {
  1180: `https://play.google.com/store/apps/details?id=${APP_INFO.T_PACKAGE}`,
  1233: `https://play.google.com/store/apps/details?id=${APP_INFO.M_PACKAGE}`,
  1340: `https://play.google.com/store/apps/details?id=${APP_INFO.LITE_PACKAGE}`
};
export const iosAppStore = {
  1180: 'https://itunes.apple.com/app/id1235601864',
  1233: 'https://itunes.apple.com/app/id835599320'
};
export const ExitGuideMaxShowTime = 1;
export const CardCollectionExitGuideMaxShowTime = 2;
export const LOTTIE_LOOP_COUNT = 3;
export enum ComponentStatus {
  SHOW = '0',
  HIDDEN = '1',
  DISABLED = '2',
}
export enum ActivityType {
  ONLY_CASH,
  CASH_COUPON,
  ONLY_COUPON,
}
export enum TaskDoneErrorNumber {
  VERIFY_PHONE = 3200,
}